import React from 'react'

const SupplierReturns = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Supplier Returns</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Receiving Goods</li>
            <li className="breadcrumb-item active">Supplier Returns</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Supplier Returns</h5>
                <p>Supplier returns content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SupplierReturns

